import { render, staticRenderFns } from "./evaluationStarList.vue?vue&type=template&id=09684aec&scoped=true"
import script from "./evaluationStarList.vue?vue&type=script&lang=js"
export * from "./evaluationStarList.vue?vue&type=script&lang=js"
import style0 from "./evaluationStarList.vue?vue&type=style&index=0&id=09684aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09684aec",
  null
  
)

export default component.exports